import { ReactKit } from '@team/react';
import { Layout } from './components/layout';
import { Button, Radio as Option } from './components/option';

export const SegmentedControl = ReactKit.createCompoundComponent(Layout, {
  Option,
  Button,
});

Layout.displayName = 'SegmentedControl';
Option.displayName = 'SegmentedControlOptionRadio';
Button.displayName = 'SegmentedControlOptionButton';
